<template>
  <div>
    <v-layout
      v-if="commentLoading"
      row
      wrap
      justify-center
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
    </v-layout>
    <v-list
      v-else
      three-line
    >
      <span class="px-2 py-1">
        Comments
      </span>
      <v-divider />
      <template v-for="comment in comments">
        <v-list-tile
          :key="comment.id"
        >
          <v-list-tile-avatar>
            <avatar
              :text="comment.author.name"
              :size="40"
              :src="comment.author.photo"
            />
          </v-list-tile-avatar>
           
          <v-list-tile-content>
            <v-list-tile-title>{{ comment.author.name }}</v-list-tile-title>
            <v-list-tile-sub-title>{{ comment.comment }}</v-list-tile-sub-title>
          </v-list-tile-content>
            
          <v-list-tile-action>
            <v-list-tile-action-text>
              {{ formatTime(comment.commentedAt) }}
            </v-list-tile-action-text>
            <v-icon
              color="primary"
              @click="deleteComment(comment)"
            >
              delete
            </v-icon>
          </v-list-tile-action>
        </v-list-tile>
      </template>
    </v-list>
    <v-dialog
      v-model="deleteDialog"
      persistent
      max-width="700px"
      transition="dialog-transition"
      lazy
    >
      <v-card class="max-shadow">
        <v-card-title class="headline">
          Delete {{ selectedComment.author.name }}'s comment?
        </v-card-title>
        <v-card-text class="subheading">
          Do you want to delete {{ selectedComment.author.name }}'s comment?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-spacer />
          <v-btn
            color="primary"
            flat
            @click="deleteDialog = false"
          >
            cancel
          </v-btn>
          <v-btn
            flat
            color="primary"
            @click="confirmDelete"
          >
            delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Avatar from '@/components/common/Avatar';
import * as moment from 'moment';
import { firestore } from '@/firebase';

export default {
  name: 'Comments',
  components: {
    avatar: Avatar
  },
  props: {
    feedId: {
      type: String,
      required: true,
      default: ''
    }
  },
  data() {
    return {
      commentLoading: false,
      comments: [],
      deleteDialog: false,
      selectedComment: {
        author: {}
      }
    };
  },
  mounted() {
    if (!this.feedId) return;
    this.commentLoading = true;
    firestore
      .collection('feed')
      .doc(this.feedId)
      .collection('comments')
      .get()
      .then(comments => {
        const docs = [];
        comments.forEach(commentSnapshot => {
          docs.push({
            ...commentSnapshot.data(),
            ...{ id: commentSnapshot.id }
          });
        });
        this.comments = docs;
        // console.log(docs);
        this.commentLoading = false;
      });
  },
  methods: {
    formatTime(timestamp) {
      const date = timestamp.toDate();
      const today = moment().startOf('day');
      return moment(date).isAfter(today)
        ? moment(date).fromNow()
        : moment(date).calendar(today, {
            lastWeek: 'DD MMM [at] hh:mm A',
            sameElse: 'DD MMM [at] hh:mm A'
          });
    },
    deleteComment(comment) {
      this.selectedComment = comment;
      this.deleteDialog = true;
    },
    confirmDelete() {
      firestore
        .collection('feed')
        .doc(this.feedId)
        .collection('comments')
        .doc(this.selectedComment.id)
        .delete()
        .then(() => {
          this.snackColor = 'primary';
          this.snackbarMessage = 'Deleted successfully';
          this.snackbar = true;
          this.comments = this.comments.filter(
            comment => comment.id !== this.selectedComment.id
          );
          this.deleteDialog = false;
        })
        .catch(() => {
          this.snackColor = 'error';
          this.snackbarMessage =
            'Something went wrong. Please try after sometime';
          this.snackbar = true;
          this.deleteDialog = false;
        });
    }
  }
};
</script>
